module.exports = __webpack_public_path__ + "img/common_vovi.6bc1fb44.png";